var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"stars"},_vm._l((5),function(star){return _c('svg',{key:star,staticClass:"star",attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[(star <= _vm.filled)?_c('path',{attrs:{"d":_vm.FILLED,"fill":"#fbcb41"}}):_c('path',{attrs:{"d":_vm.EMPTY,"fill":"#d9d9d9"}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }